import type { SVGProps } from "react";
export interface ChevronSquareUpIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ChevronSquareUpIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ChevronSquareUpIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.865 5.808A1.875 1.875 0 0 0 18 4.125H6c-1.036 0-1.875.84-1.875 1.875v12c0 1.035.84 1.875 1.875 1.875h12c1.035 0 1.875-.84 1.875-1.875V6zM22.125 18A4.125 4.125 0 0 1 18 22.125H6A4.125 4.125 0 0 1 1.875 18V6A4.125 4.125 0 0 1 6 1.875h12A4.125 4.125 0 0 1 22.125 6z"
      />
      <path
        fill={color}
        d="M12 8.375c.299 0 .585.119.796.33l3.999 4 .078.085a1.126 1.126 0 0 1-1.583 1.582l-.086-.076L12 11.09l-3.204 3.205a1.125 1.125 0 0 1-1.59-1.59l4-4.001.171-.141c.184-.122.4-.189.625-.189Z"
      />
    </svg>
  );
}
